import React, { useEffect } from "react";
import MenuButton from "./Menu-Button/MenuButton";
import logoTransparent from "../../assets/newLogo/logoTransparent.png";
import OverlayMenu from "./Overlay/Overlay";
import * as S from "./Styles";

interface NavbarProps {
  expandMenu: () => void;
  isMenuExpanded: boolean;
}

const NavBar = ({ isMenuExpanded, expandMenu }: NavbarProps) => {
  useEffect(() => {
    if (!isMenuExpanded) {
      return;
    }

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, [isMenuExpanded]);

  return (
    <S.Nav aria-label="Meny">
      <S.DesktopWrapper>
        <S.NavbarLogoContainer to="/">
          <S.NavbarLogo src={logoTransparent} alt="Grønvold Bygg logo" />
        </S.NavbarLogoContainer>
        <S.NavLinkContainer>
          <S.NavLink to="/">Hjem</S.NavLink>
          <S.NavLink to="/om-oss">Om oss</S.NavLink>
          <S.NavLink to="/kontakt">Kontakt</S.NavLink>
        </S.NavLinkContainer>
      </S.DesktopWrapper>
      <S.MobileWrapper $isMenuOpen={isMenuExpanded}>
        <S.NavbarLogoContainer to="/">
          <S.NavbarLogo src={logoTransparent} alt="Grønvold Bygg logo" />
        </S.NavbarLogoContainer>
        <S.MenuButtonContainer>
          <MenuButton toggleMenu={expandMenu} isOpen={isMenuExpanded} />
        </S.MenuButtonContainer>
        <OverlayMenu isOpen={isMenuExpanded} closeMenu={expandMenu} />
      </S.MobileWrapper>
    </S.Nav>
  );
};

export default NavBar;
